import { InferType, object, string } from "yup";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\+?[0-9]{7,15}$/;

export const feedback = object({
	name: string().required("requiredField"),
	contact: string()
		.required("requiredField")
		.test("is-valid-contact", "invalidContact", (value) => {
			if (!value) return false;
			return emailRegex.test(value) || phoneRegex.test(value);
		}),
	requestType: string().required("requiredField"),
	mtoName: string().nullable(),
	customsSystem: string().nullable(),
	subjectError: string().nullable(),
	message: string().required("requiredField"),
	image: string().nullable(),
	fileName: string().nullable(),
	requestDateTime: string().when("requestType", {
		is: (val: string) => val === "error",
		then: (schema) => schema.required("requiredField"),
		otherwise: (schema) => schema.nullable(),
	}),
	consequence: string().when("requestType", {
		is: (val: string) => val === "error",
		then: (schema) => schema.required("requiredField"),
		otherwise: (schema) => schema.nullable(),
	}),
});

export type Feedback = InferType<typeof feedback>;
